/**
 * Shared date formatting for blog surfaces.
 *
 * Pinned to `en-GB` rather than the visitor's locale so SSR and hydration agree
 * — a server rendering "12 August 2026" against a client rendering "August 12,
 * 2026" is a hydration mismatch, and Vue patches it by re-rendering the node.
 */
export function useBlogFormat() {
  const formatter = new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  /** Returns an empty string for a missing or unparseable date, never "Invalid Date". */
  function formatPostDate(value: string | null | undefined): string {
    if (!value) return "";
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? "" : formatter.format(date);
  }

  return { formatPostDate };
}
